<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter03">
<a id="page3">
</a><div class="chapterHead"><a id="page3">
</a><h2 class="chapterTitle"><a id="page3"><span class="xrefInternal"></span></a><a href="#/004TOC#chapter_03"><span class="bold">ULTRASOUND</span></a></h2></div>
<div class="chapterBody">
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">Eighteen years ago, when Dr. Stone</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">squirted the icy gel across my stomach,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">then turned to examine my womb</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">on the pulsating screen</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">and I saw Samantha for the first time,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">saw her heart fluttering like a tiny fan</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">with the effort of pumping that blood,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;"><em class="italic">my</em> blood, through her veins,</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">saw the shimmering beginnings</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">of the perfect little person</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">that my body was so effortlessly</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">knitting,</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">I couldn’t have imagined</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">how I’d feel on <em class="italic">this</em> day,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">eighteen years later,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">when Dr. Stone would squirt that gel again</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">then turn to examine my ovaries</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">on the pulsating screen,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">and announce so casually,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">as if talking about the weather:</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">“You can stop using your diaphragm now.”</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007-chapter03.vue?891bff92